import { onMounted, onUnmounted, ref, Ref } from "vue";
import * as THREE from 'three';
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";
import { getModelFile } from "@/utils";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass";
import { OutputPass } from "three/examples/jsm/postprocessing/OutputPass";
import { SMAAPass } from "three/examples/jsm/postprocessing/SMAAPass";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import Stats from 'three/examples/jsm/libs/stats.module.js';
import { LIGHT_NAME_LIST } from "./config";

let texture: THREE.DataTexture;
export async function loadHdr() {
    const loader = new RGBELoader();
    await new Promise<void>(r => {
        loader.load(getModelFile('interior.hdr'), (hdr) => {
            hdr.mapping = THREE.EquirectangularReflectionMapping;
            texture = hdr;
            r()
        });
    })
}

export function useScene(sceneRef: Ref<Element | null>, canvasWidth: Ref<number>, canvasHeight: Ref<number>, errorCb: Function) {
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, 0.45, 0.1, 1000);
    let renderer: THREE.WebGLRenderer;
    try {
        renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    } catch (e) {
        errorCb(e);
    }

    function renderScene(cb?: (camera: THREE.Camera) => void) {
        initCamera();
        initRenderer();
        // renderBlockPlane();
        if (sceneRef.value) sceneRef.value.appendChild(renderer.domElement);
        renderer.setAnimationLoop(() => {
            animate();
            cb?.(camera);
        });
    }

    function putEnvironmentAtScene() {
        scene.environment = texture;
        console.log('success');
    }

    function renderEnvironment() {
        const loader = new RGBELoader();
        loader.load(getModelFile('interior.hdr'), (texture) => {
            texture.mapping = THREE.EquirectangularReflectionMapping;
            scene.environment = texture;
        });
    }

    const showBloom = ref(false);
    function setBloomStatus(value: boolean) {
        showBloom.value = value;
    }
    function renderBloom() {
        const renderScene = new RenderPass(scene, camera);

        const bloomPass = new UnrealBloomPass(new THREE.Vector2(window.innerWidth, window.innerHeight), 0, 0.4, 0.8);
        const outputPass = new OutputPass();
        const smaaPass = new SMAAPass(canvasWidth.value * window.devicePixelRatio, canvasHeight.value * window.devicePixelRatio);

        let composer = new EffectComposer(renderer);

        composer.addPass(renderScene);
        composer.addPass(bloomPass);
        composer.addPass(smaaPass);
        composer.addPass(outputPass);
        
        // const finalComposer = new EffectComposer( renderer );
        // finalComposer.addPass( renderScene );
        // finalComposer.addPass( mixPass );
        // finalComposer.addPass(smaaPass);
        // finalComposer.addPass( outputPass );

        // composer.setSize( window.innerWidth, window.innerHeight );
        // finalComposer.setSize( window.innerWidth, window.innerHeight );

        renderer.setAnimationLoop(() => {
            if (!showBloom.value) return bloomPass.strength = 0;
            if (bloomPass.strength <= 0.2) bloomPass.strength += 0.001;

            // composer.render();
            

            renderer.autoClear = false;
            renderer.clear();
            camera.layers.mask = 1;
            composer.render();
            renderer.clearDepth();
            camera.layers.mask = 2;
            renderer.render(scene, camera);

            // scene.traverse( darkenNonBloomed );
            // composer.render();
            // scene.traverse( restoreMaterial );
            // finalComposer.render();
        });
    }

    function renderBlockPlane() {
        const clipPlane = new THREE.Plane(new THREE.Vector3(0, 0, 1), 8);

        // 设置相机的裁剪平面
        renderer.clippingPlanes = [clipPlane];
        renderer.localClippingEnabled = true;
    }

    function initCamera() {
        camera.position.set(0, 0, 10);
    }

    function initRenderer() {
        renderer.toneMapping = THREE.NeutralToneMapping;
        renderer.toneMappingExposure = 0.8;
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(canvasWidth.value, canvasHeight.value);
    }

    function animate() {
        render()
    }

    function render() {
        renderer.render(scene, camera);
    }

    function renderStats() {
        const stats = new Stats();
        document.body.appendChild(stats.dom);
        function animate() {
            stats.update();
            requestAnimationFrame(animate);
        }
        requestAnimationFrame(animate);
    }

    function disposeScene(scene) {
        scene.traverse((object) => {
            if (object.isMesh) {
                disposeObject(object);
            }
        });
    }

    function disposeObject(object) {
        if (object.geometry) {
            object.geometry.dispose();
        }
        if (object.material) {
            if (Array.isArray(object.material)) {
                object.material.forEach(material => material.dispose());
            } else {
                object.material.dispose();
            }
        }
    }

    function disposeRenderer(renderer) {
        renderer.dispose();
    }

    function destroyThreeComponents() {
        disposeScene(scene);
        disposeRenderer(renderer);
    }

    onUnmounted(destroyThreeComponents);

    return {
        scene,
        camera,
        renderScene,
        renderBloom,
        renderStats,
        // renderEnvironment,
        putEnvironmentAtScene,
        setBloomStatus,
    }
}